import { atom, useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { accountActivityCacheKey, queryFnFactory } from '@syf-api-library/account-activity';
export const apiConfigAtom = atom();
export const accountActivityAtom = atomWithQuery((get) => {
    const apiConfig = get(apiConfigAtom);
    return {
        queryKey: accountActivityCacheKey(apiConfig.keyProps),
        queryFn: queryFnFactory(apiConfig.config, apiConfig.keyProps),
        queryOptions: Object.assign({}, apiConfig.queryOptions)
    };
});
export const accountActivityDataAtom = atom((get) => get(accountActivityAtom), (get, set, update) => {
    return update;
});
export const useAccountActivity = () => {
    return useAtom(accountActivityAtom);
};
export const invalidateAccountActivity = (apiConfig, queryClient) => {
    queryClient.invalidateQueries(accountActivityCacheKey(apiConfig.keyProps));
};
